// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1581":"d41d4909","7571":"4113a8e7"}[chunkId] + ".chunk.css";
};